import React from "react";
import { splitText } from "./Utils";
import SourceValue from "./SourceValue";

interface StackedTextProps {
  value: string | undefined | null;
}

const StackedText: React.FC<StackedTextProps> = ({ value }) => {
  const items = splitText(value);

  if (items.length === 0) return null;

  return (
    <div
      style={{ display: "flex", flexDirection: "column", lineHeight: "1.4" }}
    >
      {items.map((item, index) => (
        <span style={{ color: "#ffffff" }} key={`${item}-${index}`}>
          <SourceValue value={item} />
        </span>
      ))}
    </div>
  );
};

export default StackedText;
